import {Breadcrumbs, Title} from '@management-ui/core';
import * as React from 'react';
import TableHolder from '../../../../components/TableHolder';
import Table from './Table';

const Inbox = () => (
  <div>
    <Breadcrumbs crumbs={[{title: 'Inbox'}]}/>
    <Title title="Inbox"/>
    <TableHolder>
      <Table/>
    </TableHolder>
  </div>
);

export default Inbox;
